import { Container } from "react-bootstrap";

import blindness from "../assets/img/publications/blindness.jpg";
import crowd1 from "../assets/img/publications/virtualcrowd.png";
import crowd2 from "../assets/img/publications/crowd2.png";
import crowd25 from "../assets/img/publications/crowd2_5.jpg";
import crowd3 from "../assets/img/publications/crowd3.png";
import crowd4 from "../assets/img/publications/crowd4.jpg";

import avoid from "../assets/img/publications/avoidance.png";
import avoid1 from "../assets/img/publications/avoidance1.png";
import avoid2 from "../assets/img/publications/avoidance2.png";

import skateboard1 from "../assets/img/publications/teaser.jpg";
import skateboard2 from "../assets/img/publications/skateboard2.png";
import skateboard3 from "../assets/img/publications/skateboard3.png";
import skateboard4 from "../assets/img/publications/skateboard4.jpg";

const publications = [
  {
    year: "2026",
    title:
      "Balancing the Virtual Path: Influence of Amplitude, Frequency, and Input Method on VR Locomotion",
    venue:
      "IEEE Transactions on Visualization and Computer Graphics · Proc. IEEE VR 2026",
    imgUrl: skateboard4,
    category: "VR LOCOMOTION",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/jour26-IEEETVCG-AmplitudeFrequencyBalanceBoard.pdf",
      },
      {
        label: "DOI",
        url: "https://doi.org/10.1109/TVCG.2026.3680614",
      },
    ],
  },
  {
    year: "2026",
    title:
      "Demographic Influences on Balance-Based Locomotion in Virtual Reality",
    venue:
      "IEEE Conference on Virtual Reality and 3D User Interfaces Abstracts and Workshops",
    imgUrl: skateboard3,
    category: "VR LOCOMOTION",
    links: [
      {
        label: "DOI",
        url: "https://doi.org/10.1109/VRW70859.2026.00059",
      },
    ],
  },
  {
    year: "2025",
    title:
      "Isometric and Elastic Balance Boards for Virtual Reality Locomotion",
    venue:
      "IEEE International Symposium on Mixed and Augmented Reality (ISMAR)",
    imgUrl: skateboard2,
    category: "VR LOCOMOTION",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/conf25-IEEEISMAR-IsometricElasticBalanceBoards.pdf",
      },
      {
        label: "DOI",
        url: "https://doi.org/10.1109/ISMAR67309.2025.00018",
      },
    ],
  },
  {
    year: "2024",
    title: "Comparing Control Schemas in Isometric Balanced-based Controllers",
    venue:
      "IEEE International Symposium on Mixed and Augmented Reality Adjunct (ISMAR-Adjunct)",
    imgUrl: skateboard1,
    category: "VR LOCOMOTION",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/conf24-IEEEISMAR-Adjunct-ControlSchemasIsometricBalancedControllers.pdf",
      },
      {
        label: "DOI",
        url: "https://doi.org/10.1109/ISMAR-Adjunct64951.2024.00031",
      },
    ],
  },
  {
    year: "2024",
    title: "Avoiding Virtual Characters: The Effects of Proximity and Gesture",
    venue:
      "IEEE International Symposium on Mixed and Augmented Reality (ISMAR)",
    imgUrl: avoid2,
    category: "VIRTUAL HUMANS",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/conf24-IEEEISMAR-ProximityGesture.pdf",
      },
      {
        label: "DOI",
        url: "https://doi.org/10.1109/ISMAR62088.2024.00018",
      },
    ],
  },
  {
    year: "2023",
    title:
      "Effects of Speed of a Collocated Virtual Walker and Proximity Toward a Static Virtual Character on Avoidance Movement Behavior",
    venue:
      "IEEE International Symposium on Mixed and Augmented Reality (ISMAR)",
    imgUrl: avoid1,
    category: "VIRTUAL HUMANS",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/conf23-IEEEISMAR-CollocatedAvoidance.pdf",
      },
      {
        label: "DOI",
        url: "https://doi.org/10.1109/ISMAR59233.2023.00109",
      },
    ],
  },
  {
    year: "2022",
    title:
      "Effects of Rendering Styles of a Virtual Character on Avoidance Movement Behavior",
    venue:
      "IEEE International Symposium on Mixed and Augmented Reality Adjunct (ISMAR-Adjunct)",
    imgUrl: avoid,
    category: "VIRTUAL HUMANS",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/conf22-IEEEISMAR-Adjunct-RealisticAppearanceAvoidance.pdf",
      },
      {
        label: "DOI",
        url: "https://doi.org/10.1109/ISMAR-Adjunct57072.2022.00123",
      },
    ],
  },
  {
    year: "2020",
    title:
      "Walking in a Crowd Full of Virtual Characters: Effects of Virtual Character Appearance on Human Movement Behavior",
    venue: "International Symposium on Visual Computing",
    imgUrl: crowd4,
    category: "VIRTUAL CROWDS",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/conf20-ISVC-CrowdAppearance.pdf",
      },
    ],
  },
  {
    year: "2020",
    title:
      "A Virtual Reality Framework for Human-Virtual Crowd Interaction Studies",
    venue:
      "IEEE International Conference on Artificial Intelligence and Virtual Reality (AIVR)",
    imgUrl: crowd3,
    category: "VIRTUAL CROWDS",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/conf20-AIVR-CrowdInteractionFramework.pdf",
      },
    ],
  },
  {
    year: "2020",
    title:
      "Evaluating Human Movement Coordination During Immersive Walking in a Virtual Crowd",
    venue: "Behavioral Sciences · 10(9), 130",
    imgUrl: crowd25,
    category: "VIRTUAL CROWDS",
    links: [
      {
        label: "PAPER",
        url: "https://www.mdpi.com/2076-328X/10/9/130",
      },
      {
        label: "DOI",
        url: "https://doi.org/10.3390/bs10090130",
      },
    ],
  },
  {
    year: "2020",
    title:
      "Immersive Walking in a Virtual Crowd: The Effects of the Density, Speed, and Direction of a Virtual Crowd on Human Movement Behavior",
    venue: "Computer Animation and Virtual Worlds · 31, e1928",
    imgUrl: crowd2,
    category: "VIRTUAL CROWDS",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/jour20-CAVW-ImmersiveCrowd.pdf",
      },
      {
        label: "DOI",
        url: "https://doi.org/10.1002/cav.1928",
      },
    ],
  },
  {
    year: "2020",
    title: "Blindness Visualizer: A Simulated Navigation Experience",
    venue:
      "IEEE Conference on Virtual Reality and 3D User Interfaces Abstracts and Workshops (VRW)",
    imgUrl: blindness,
    category: "VR EXPERIENCE",
    links: [
      {
        label: "PAPER",
        url: "https://web.ics.purdue.edu/~cmousas/papers/conf20-IEEEVR-Blindness.pdf",
      },
      {
        label: "DOI",
        url: "https://doi.org/10.1109/VRW50115.2020.00107",
      },
    ],
  },
  {
    year: "2019",
    title:
      "Within a Virtual Crowd: Exploring Human Movement Behavior during Immersive Virtual Crowd Interaction",
    venue:
      "ACM SIGGRAPH Conference on Virtual-Reality Continuum and Its Applications in Industry (VRCAI)",
    imgUrl: crowd1,
    category: "VIRTUAL CROWDS",
    links: [
      {
        label: "DOI",
        url: "https://doi.org/10.1145/3359997.3365709",
      },
    ],
  },
];

export const Publications = () => {
  return (
    <section className="publications" id="publications">
      <Container>
        <header className="publications-header">
          <span className="section-label">RESEARCH</span>

          <h2>Publications</h2>

          <p>
            Peer-reviewed research in virtual reality locomotion, human–virtual
            character interaction, virtual crowds, and immersive simulation.
          </p>
        </header>

        <div className="publications-list">
          {publications.map((publication) => {
            const primaryUrl = publication.links[0]?.url;

            return (
              <article
                className="publication-card"
                key={`${publication.year}-${publication.title}`}
              >
                <a
                  className="publication-image-link"
                  href={primaryUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Open ${publication.title}`}
                >
                  <img
                    className="publication-image"
                    src={publication.imgUrl}
                    alt=""
                  />
                </a>

                <div className="publication-content">
                  <div className="publication-meta">
                    <span>{publication.category}</span>
                    <span className="publication-year">{publication.year}</span>
                  </div>

                  <h3>
                    <a
                      href={primaryUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {publication.title}
                    </a>
                  </h3>

                  <p className="publication-venue">{publication.venue}</p>

                  <div className="publication-links">
                    {publication.links.map((link) => (
                      <a
                        key={link.label}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.label} ↗
                      </a>
                    ))}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </Container>
    </section>
  );
};
